<template>
    <div id="how-it-works-emerge">
        <section id="emerge-banner-investors" class="section section-padding bg-color-light-gray mb--50 sunflower-supplier">
            <div class="container">
                <div class="section-heading heading-light-left mb--100">
                    <span class="subtitle emerge-red bold">¿Cómo funciona?</span>
                    <h2 class="font-weight-100">¿Cómo <span class="bold">invertir</span>?</h2>
                </div>
                <div class="row justify-content-center">
                    <div class="col-sm-6 col-md-3 col-lg-3">
                        <div class="about-quality active">
                            <div class="bullet cursor-icon" :style="`background-image: url(${img1});`"></div>
                            <h5 class="title black bold">1. Crea tu cuenta</h5>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3">
                        <div class="about-quality">
                            <div class="bullet money" :style="`background-image: url(${img2});`"></div>
                            <h5 class="title black bold">2. Encuentra el proyecto</h5>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3">
                        <div class="about-quality">
                            <div class="bullet money" :style="`background-image: url(${img3});`"></div>
                            <h5 class="title black bold">3. Invierte desde $500</h5>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3 col-lg-3">
                        <div class="about-quality">
                            <div class="bullet money" :style="`background-image: url(${img4});`"></div>
                            <h5 class="title black bold">4. Gana cada mes</h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data: () => ({
            img1: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-step-01.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-step-02.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-step-03.png",
            img4: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-step-04.png",
        }),
    }
</script>

<style>
#emerge-banner-investors {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/emerge/banners/emerge-banner-03.png");
    /* background-position: right; */
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #f1f1f1 !important;
}

@media (max-width: 750px){
    #emerge-banner-investors {
        background-image: none;
    }
}

div.bullet {
    background-repeat: no-repeat;
    background-size: 4.5rem;
    width: 6rem !important;
    height: 6rem !important;
    border-radius: 0 !important;
}

.bullet.cursor-icon {
    background-size: 3.5rem !important;
    background-position-x: 1rem !important;
    background-repeat: no-repeat;
}

.bullet.money {
    background-size: 5rem;
    background-repeat: no-repeat;
}
</style>